import { Tabs } from 'antd';
import { useOrg } from 'hooks/useOrg';
import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { isRegularOrg } from 'domains/orgDomain';
import ElementOverrideTab from './ElementOverrideTab';
import ElementTab from './ElementTab';
import GlobalOverrideTab from './GlobalOverrideTab';
import GlobalTab from './GlobalTab';
import RevshopOverrideTab from './RevshopOverrideTab';
import RevshopTab from './RevshopTab';
import OrgSkuMarkupTab from './OrgSkuMarkupTab';
import RevshopSkuMarkupTab from './RevshopSkuMarkupTab';
import RevshopShippingMarkupTab from './RevshopShippingMarkupTab';
import { useAppDispatch } from 'app/hooks';
import OutsourcePrintingTab from './OutsourcePrintingTab';
import OutsourceShippingTab from './OutsourceShippingTab';
import RevshopOrgMarkupsTab from './RevshopOrgMarkupsTab';

const MarkupAdminContainer = () => {
  const { t } = useTranslation();
  const contextOrg = useOrg();
  const regular = contextOrg && isRegularOrg(contextOrg);
  const dispatch = useAppDispatch();
  useEffect(() => {
    dispatch.markup.setState({ contextMode: regular ? 'regular' : 'revshop' });
  }, [dispatch.markup, regular]);

  return regular ? (
    <Tabs
      defaultActiveKey="1"
      tabPosition="left"
      style={{ height: '100%', backgroundColor: 'white', paddingTop: 8 }}
    >
      <Tabs.TabPane tab={t('platform.markup.tabs.element')} key="1">
        <ElementTab />
      </Tabs.TabPane>
      <Tabs.TabPane tab={t('platform.markup.tabs.elementOverride')} key="2">
        <ElementOverrideTab />
      </Tabs.TabPane>
      <Tabs.TabPane tab={t('platform.markup.tabs.global')} key="3">
        <GlobalTab />
      </Tabs.TabPane>
      <Tabs.TabPane tab={t('platform.markup.tabs.globalOverride')} key="4">
        <GlobalOverrideTab />
      </Tabs.TabPane>
      <Tabs.TabPane tab={t('platform.markup.tabs.sku')} key="5">
        <OrgSkuMarkupTab />
      </Tabs.TabPane>
      <Tabs.TabPane tab={t('platform.markup.tabs.outsourcePrinting')} key="6">
        <OutsourcePrintingTab />
      </Tabs.TabPane>
      <Tabs.TabPane tab={t('platform.markup.tabs.outsourceShipping')} key="7">
        <OutsourceShippingTab />
      </Tabs.TabPane>
    </Tabs>
  ) : (
    <Tabs
      defaultActiveKey="1"
      tabPosition="left"
      style={{ height: '100%', backgroundColor: 'white' }}
    >
      <Tabs.TabPane tab={t('platform.markup.tabs.revshop')} key="1">
        <RevshopTab />
      </Tabs.TabPane>
      <Tabs.TabPane tab={t('platform.markup.tabs.revshopOverride')} key="2">
        <RevshopOverrideTab />
      </Tabs.TabPane>
      <Tabs.TabPane tab={t('platform.markup.tabs.revshopSku')} key="3">
        <RevshopSkuMarkupTab />
      </Tabs.TabPane>
      <Tabs.TabPane tab={t('platform.markup.tabs.revshopShipping')} key="4">
        <RevshopShippingMarkupTab />
      </Tabs.TabPane>
      <Tabs.TabPane tab={t('platform.markup.tabs.RevshopOrgMarkups')} key="5">
        <RevshopOrgMarkupsTab />
      </Tabs.TabPane>
    </Tabs>
  );
};

export default MarkupAdminContainer;
